(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-product-services"] && !Shopify.designMode) return;
  try {
    function rcNativeShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0||delivery.getUTCDay()===6)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}
function initRcProductServices(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 const tick=()=>{const state=rcNativeShippingState(new Date()),remaining=state.seconds;
 root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
 root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
 root.querySelector('[data-zp-shipping-label]').textContent=state.label;
 root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(n=>String(n).padStart(2,'0')).join(':');
 shipping.hidden=!state.showTimer;};
 tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
}
document.querySelectorAll('[data-rc-product-services]').forEach(initRcProductServices);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-rc-product-services]').forEach(initRcProductServices));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-sticky-buy"] && !Shopify.designMode) return;
  try {
    function initRcStickyBuy(bar){
 if(bar.dataset.initialized)return;
 const root=bar.closest('.zp,[data-rc-native-product]'),button=bar.querySelector('[data-rc-sticky-add]');
 const form=document.getElementById(button.getAttribute('form'));
 const purchase=form?.closest('.zp-purchase,.buy-buttons-block'),mainButton=form?.querySelector('[name="add"]'),price=root?.querySelector('[data-zp-price],product-price');
 if(!root||!form||!purchase||!mainButton)return;
 bar.dataset.initialized='true';
 const sync=()=>{button.disabled=mainButton.disabled;button.textContent=(!mainButton.disabled&&button.dataset.customLabel)||(mainButton.querySelector('[data-zp-add-label],.add-to-cart-text__content')||mainButton).textContent.trim();if(price)bar.querySelector('[data-rc-sticky-price]').textContent=price.textContent;};
 const resize=()=>{const height=bar.getBoundingClientRect().height;if(height>0)root.style.setProperty('--rc-sticky-height',height+'px');};
 const footer=document.querySelector('.page-wrapper > footer')||document.querySelector('footer');
 let purchasePassed=false,footerVisible=false;
 const updateVisibility=()=>{
  bar.toggleAttribute('data-rc-reserve-space',purchasePassed);
  bar.hidden=!purchasePassed||footerVisible;
  if(!bar.hidden)resize();
 };
 const observer=new IntersectionObserver(entries=>{
  for(const entry of entries){
   if(entry.target===purchase)purchasePassed=!entry.isIntersecting&&entry.boundingClientRect.bottom<=0;
   if(entry.target===footer)footerVisible=entry.isIntersecting;
  }
  updateVisibility();
 },{threshold:0});
 const stateObserver=new MutationObserver(sync);
 observer.observe(purchase);if(footer)observer.observe(footer);stateObserver.observe(mainButton,{attributes:true,attributeFilter:['disabled'],childList:true,subtree:true,characterData:true});
 if(price)stateObserver.observe(price,{childList:true,subtree:true,characterData:true});
 const resizeObserver=new ResizeObserver(resize);resizeObserver.observe(bar);sync();
 bar.rcStickyCleanup=()=>{observer.disconnect();stateObserver.disconnect();resizeObserver.disconnect();};
}
document.querySelectorAll('[data-rc-sticky-buy]').forEach(initRcStickyBuy);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-rc-sticky-buy]').forEach(initRcStickyBuy));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-rc-sticky-buy]').forEach(bar=>bar.rcStickyCleanup?.()));
  } catch(e) { console.error(e); }
})();

})();
